<template>
  <div>
    <PageTitle
      title="Edit Expense Setting"
      :showLoading="isLoading"
      :backBtn="true"
    />
    <ValidationObserver ref="observer">
      <v-container fluid class="lighten-12">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>General </v-card-title>
              <v-container fluid class="light gray lighten-12 container-card">
                <v-row>
                  <v-col lg="4" md="6" sm="4">
                    <v-radio-group v-model="ExpenseSetting.expense_for" row>
                      <v-radio label="Warehouse" value="Warehouse"></v-radio>
                      <v-radio label="Shop" value="Shop"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" sm="6" lg="6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Repeat"
                      rules="required"
                    >
                      <v-select
                        outlined
                        dense
                        item-text="name"
                        item-value="id"
                        v-model="ExpenseSetting.repeat"
                        :items="repeats"
                        :error-messages="errors"
                        label="Repeat"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="6" sm="6" lg="6">
                    <v-text-field
                      v-if="ExpenseSetting.repeat == 'Every Day'"
                      v-model="ExpenseSetting.date"
                      label="Date"
                      dense
                      disabled
                      outlined
                    ></v-text-field>
                    <ValidationProvider
                      rules="required"
                      v-else
                      v-slot="{ errors }"
                      name="Date"
                    >
                      <datePickComponent
                        labelname="Date"
                        v-model="ExpenseSetting.date"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Parent Expense category"
                    >
                      <treeselect
                        hide-details="auto"
                        outlined
                        :error-messages="errors"
                        required
                        class="tree-border"
                        :value="id"
                        dense
                        v-model="ExpenseSetting.category.id"
                        filled
                        :options="expense_categories_with_childs"
                        placeholder="Select your parent expense category"
                      >
                        <label
                          hide-details="auto"
                          slot="option-label"
                          slot-scope="{
                            node,
                            shouldShowCount,
                            count,
                            labelClassName,
                            countClassName,
                          }"
                          :class="labelClassName"
                        >
                          {{ node.raw.label }}
                          <span v-if="shouldShowCount" :class="countClassName"
                            >({{ count }})</span
                          >
                        </label>
                      </treeselect>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="6"
                    v-if="ExpenseSetting.expense_for == 'Warehouse'"
                  >
                    <ValidationProvider rules="required" name="Warehouse">
                      <v-autocomplete
                        outlined
                        slot-scope="{ errors }"
                        hide-details="auto"
                        v-model="ExpenseSetting.warehouse"
                        item-text="name"
                        item-value="id"
                        :items="warehouses"
                        :search-input.sync="searchWarehouse"
                        :loading="warehouseLoading"
                        :error-messages="errors"
                        label="Warehouse"
                        required
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="6" v-if="ExpenseSetting.expense_for == 'Shop'">
                    <ValidationProvider rules="required" name="shop">
                      <v-autocomplete
                        outlined
                        slot-scope="{ errors }"
                        hide-details="auto"
                        v-model="ExpenseSetting.shop"
                        item-text="name"
                        item-value="id"
                        :items="shops"
                        :search-input.sync="searchShop"
                        :error-messages="errors"
                        label="Shops"
                        required
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Amount"
                      rules="required"
                    >
                      <v-text-field
                        :error-messages="errors"
                        v-model="ExpenseSetting.amount"
                        label="Amount"
                        auto-grow
                        outlined
                        hide-details="auto"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      name="Remark"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        :error-messages="errors"
                        required
                        label="Note"
                        v-model="ExpenseSetting.remark"
                        outlined
                        rows="3"
                      ></v-textarea>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="1" md="6" sm="1"></v-col>
                  <v-col lg="4" md="6" sm="4">
                    <ValidationProvider v-slot="{ errors }" name="Repeat End">
                      <v-switch
                        v-model="ExpenseSetting.is_repeat_end"
                        flat
                        label="Repeat End"
                        input-value="false"
                        :error-messages="errors"
                      ></v-switch>
                    </ValidationProvider>
                  </v-col>
                  <v-col lg="1" md="6" sm="1"></v-col>
                  <v-col lg="6" md="6" sm="6">
                    <v-text-field
                      v-if="ExpenseSetting.is_repeat_end == false"
                      v-model="ExpenseSetting.repeat_end"
                      label="Repeat End Date"
                      dense
                      disabled
                      outlined
                    ></v-text-field>
                    <ValidationProvider
                      rules="required"
                      v-else
                      v-slot="{ errors }"
                      name="Repeat End Date"
                    >
                      <datePickComponent
                        labelname="Repeat End Date"
                        v-model="ExpenseSetting.repeat_end"
                        :error-messages="errors"
                        hide-details="auto"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-col cols="12" class="text-right pa-0">
          <v-btn
            @click="clear"
            depressed
            small
            class="ml-1 text-white btn_medium"
            >clear</v-btn
          >
          <v-btn
            @click="submit"
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            >submit</v-btn
          >
        </v-col>
      </v-container>
    </ValidationObserver>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import DatePicker from 'vue2-datepicker';
import { mapState } from 'vuex';
import 'vue2-datepicker/index.css';
import datePickComponent from '@/components/base/DateComponent';
import axios from '@/plugins/axios';
import * as moment from 'moment/moment';
import { required } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import ServerMessages from '@/components/shared/ServerMessages';
setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

export default {
  components: {
    Treeselect,
    ValidationProvider,
    ValidationObserver,
    ServerMessages,
    datePickComponent,
    DatePicker,
  },
  data: () => ({
    warehouses: [],
    searchWarehouse: null,
    expenseLoading: false,
    expenseCategories: [],
    value: [],
    shops: [],
    ExpenseSetting: null,
    repeats: [
      { id: 'Every Day', name: 'Every Day' },
      { id: 'Every Month', name: 'Every Month' },
      { id: 'Every Year', name: 'Every Year' },
    ],

    isLoading: false,
    errors: [],
    messages: [],
  }),

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    expenseCategory: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  computed: {
    ...mapState('ExpenseSetting', ['expense_categories_with_childs']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.expenseCategory);
        }
      },
    },
  },
  methods: {
    GetExpenseSetting() {
      let expensesettingId = this.$route.params.id;

      axios
        .get(`settings/expense-settings/${expensesettingId}`)
        .then((res) => {
          this.ExpenseSetting = res.data;
          if (res.data.date) {
            this.ExpenseSetting.date = moment(res.data.date).format(
              'YYYY-MM-DD',
            );

            this.ExpenseSetting.warehouse = res?.data?.warehouse?.id;
            this.ExpenseSetting.shop = res?.data?.shop?.id;
          }
          if (res.data.repeat_end) {
            this.ExpenseSetting.repeat_end = moment(res.data.repeat_end).format(
              'YYYY-MM-DD',
            );
          }
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },

    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.EditExpense();
      }
    },
    clear() {
      this.show = false;
      this.expenseCategory = new ProductCategory();

      this.$refs.observer.reset();
    },

    getWarehouseByQuery(query = '') {
      this.warehouseLoading = true;
      this.$store
        .dispatch('warehouse/GetWarehouse', { query: query, status: 'active' })
        .then((res) => {
          this.warehouses = res;
          this.warehouseLoading = false;
        })
        .catch((err) => {
          this.warehouseLoading = false;
          this.messages = err.data.name;
        });
    },
    async getAllShops(value) {
      await this.$store
        .dispatch('shop/GetShop', {})
        .then((res) => {
          this.shops = res;
        })
        .catch((err) => {});
    },
    getExpenseCategoriesByQuery() {
      this.expenseLoading = true;
      this.$store
        .dispatch('sitesetting/GetExpenseCategories')
        .then((res) => {
          this.expenseCategories = res.data.data;
          this.expenseLoading = false;
        })
        .catch((err) => {
          this.expenseLoading = false;
          this.messages = err.data.name;
        });
    },
    EditExpense() {
      this.isLoading = true;
      let credentials = this.ExpenseSetting;
      credentials.category_id = this.ExpenseSetting.category.id;

      this.ExpenseSetting.warehouse
        ? ((credentials.warehouse_id = this.ExpenseSetting.warehouse),
          (credentials.shop_id = null))
        : ((credentials.shop_id = this.ExpenseSetting.shop),
          (credentials.warehouse_id = null));

      this.$store
        .dispatch('ExpenseSetting/EditExpenseSetting', credentials)
        .then(async (res) => {
          this.succeeed = true;
          this.$emit('afterSave');
          this.$toast.success('Expense setting edited successfully');
          this.$router.push('/expensesetting');
          this.isLoading = false;
          this.show = false;
          this.expenseCategory = new ExpenseCategory();
          this.$refs.observer.reset();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to edit expense setting.');
          this.isLoading = false;
        });
    },
    GetExpenseCategoriesWithChild() {
      this.$store
        .dispatch('ExpenseSetting/GetExpenseCategoriesWithChild')
        .then((res) => {})
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
        });
    },
  },
  created() {
    this.GetExpenseCategoriesWithChild();
    this.GetExpenseSetting();
    this.getExpenseCategoriesByQuery();
    this.getWarehouseByQuery();
    this.getAllShops('');
  },

  watch: {
    searchWarehouse(value) {
      if (!value) {
        this.getWarehouseByQuery('');
      }
      this.getWarehouseByQuery(value);
    },

    'ExpenseSetting.expense_for'(newVal) {
      if (newVal === 'Warehouse') {
        this.ExpenseSetting.shop = null;
      } else if (newVal === 'Shop') {
        this.ExpenseSetting.warehouse = null;
      }
    },
  },
};
</script>
